import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "stroke-checked",
  "use": "stroke-checked-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"stroke-checked\"><path fill-rule=\"evenodd\" d=\"M16 1.3 5.55 11.75 0 6.2l1.3-1.3 4.25 4.25L14.7 0z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol